import * as Types from '../../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DailyLessonInstructorCommentModalKollegeExpenseRecordDailyLessonInputFragment = { __typename?: 'KollegeExpenseRecordDailyLessonInput', guid: string, title: string, instructorComment?: string | null, expenseShokuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseNichiyouhin: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseIryohi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseHifukuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseBiyouhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKousaihi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseGorakuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKodomohi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKoutsuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseGasolinedai: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseZappi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseTokubetsuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null } };

export type DailyLessonInstructorCommentModalKollegeUserQueryVariables = Types.Exact<{
  userSubGuid: Types.Scalars['ID']['input'];
  nthDay: Types.Scalars['Int']['input'];
}>;


export type DailyLessonInstructorCommentModalKollegeUserQuery = { __typename?: 'Query', kollegeUser?: { __typename?: 'KollegeUser', standardCourse?: { __typename?: 'KollegeUserCourse_StandardV20250418', expenseRecordDailyLesson?: { __typename?: 'KollegeExpenseRecordDailyLesson', guid: string, period?: { __typename?: 'KollegeExpenseRecordDailyLessonPeriod', startsAt: TimeString } | null, input: Array<{ __typename?: 'KollegeExpenseRecordDailyLessonInput', guid: string, title: string, instructorComment?: string | null, expenseShokuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseNichiyouhin: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseIryohi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseHifukuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseBiyouhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKousaihi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseGorakuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKodomohi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseKoutsuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseGasolinedai: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseZappi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null }, expenseTokubetsuhi: { __typename?: 'KollegeExpenseItem', amount?: number | null, sakugenkahi?: Types.KollegeSakugenkahi | null } }> } | null } | null } | null };

export type DailyLessonInstructorCommentModalKollegeUserFragment = { __typename?: 'KollegeUser', id: string, profile?: { __typename?: 'KollegeUserProfile', familyName: string, givenName: string } | null };

export type UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationVariables = Types.Exact<{
  expenseRecordDailyLessonInputID: Types.Scalars['ID']['input'];
  instructorComment: Types.NullableString;
}>;


export type UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation = { __typename?: 'Mutation', updateKollegeExpenseRecordDailyLessonInstructorComment: { __typename?: 'KollegeExpenseRecordDailyLessonInput', guid: string, instructorComment?: string | null } };

export const DailyLessonInstructorCommentModalKollegeExpenseRecordDailyLessonInputFragmentDoc = gql`
    fragment DailyLessonInstructorCommentModalKollegeExpenseRecordDailyLessonInput on KollegeExpenseRecordDailyLessonInput {
  guid
  title
  instructorComment
  expenseShokuhi {
    amount
    sakugenkahi
  }
  expenseNichiyouhin {
    amount
    sakugenkahi
  }
  expenseIryohi {
    amount
    sakugenkahi
  }
  expenseHifukuhi {
    amount
    sakugenkahi
  }
  expenseBiyouhi {
    amount
    sakugenkahi
  }
  expenseKousaihi {
    amount
    sakugenkahi
  }
  expenseGorakuhi {
    amount
    sakugenkahi
  }
  expenseKodomohi {
    amount
    sakugenkahi
  }
  expenseKoutsuhi {
    amount
    sakugenkahi
  }
  expenseGasolinedai {
    amount
    sakugenkahi
  }
  expenseZappi {
    amount
    sakugenkahi
  }
  expenseTokubetsuhi {
    amount
    sakugenkahi
  }
}
    `;
export const DailyLessonInstructorCommentModalKollegeUserFragmentDoc = gql`
    fragment DailyLessonInstructorCommentModalKollegeUser on KollegeUser {
  id
  profile {
    familyName
    givenName
  }
}
    `;
export const DailyLessonInstructorCommentModalKollegeUserDocument = gql`
    query DailyLessonInstructorCommentModalKollegeUser($userSubGuid: ID!, $nthDay: Int!) {
  kollegeUser(id: $userSubGuid) {
    standardCourse {
      expenseRecordDailyLesson {
        guid
        period {
          startsAt
        }
        input(nth_day: [$nthDay]) {
          ...DailyLessonInstructorCommentModalKollegeExpenseRecordDailyLessonInput
        }
      }
    }
  }
}
    ${DailyLessonInstructorCommentModalKollegeExpenseRecordDailyLessonInputFragmentDoc}`;

/**
 * __useDailyLessonInstructorCommentModalKollegeUserQuery__
 *
 * To run a query within a Vue component, call `useDailyLessonInstructorCommentModalKollegeUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDailyLessonInstructorCommentModalKollegeUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDailyLessonInstructorCommentModalKollegeUserQuery({
 *   userSubGuid: // value for 'userSubGuid'
 *   nthDay: // value for 'nthDay'
 * });
 */
export function useDailyLessonInstructorCommentModalKollegeUserQuery(variables: DailyLessonInstructorCommentModalKollegeUserQueryVariables | VueCompositionApi.Ref<DailyLessonInstructorCommentModalKollegeUserQueryVariables> | ReactiveFunction<DailyLessonInstructorCommentModalKollegeUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>(DailyLessonInstructorCommentModalKollegeUserDocument, variables, options);
}
export function useDailyLessonInstructorCommentModalKollegeUserLazyQuery(variables?: DailyLessonInstructorCommentModalKollegeUserQueryVariables | VueCompositionApi.Ref<DailyLessonInstructorCommentModalKollegeUserQueryVariables> | ReactiveFunction<DailyLessonInstructorCommentModalKollegeUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>(DailyLessonInstructorCommentModalKollegeUserDocument, variables, options);
}
export type DailyLessonInstructorCommentModalKollegeUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DailyLessonInstructorCommentModalKollegeUserQuery, DailyLessonInstructorCommentModalKollegeUserQueryVariables>;
export const UpdateKollegeExpenseRecordDailyLessonInstructorCommentDocument = gql`
    mutation UpdateKollegeExpenseRecordDailyLessonInstructorComment($expenseRecordDailyLessonInputID: ID!, $instructorComment: NullableString!) {
  updateKollegeExpenseRecordDailyLessonInstructorComment(
    input: {expenseRecordDailyLessonInputID: $expenseRecordDailyLessonInputID, instructorComment: $instructorComment}
  ) {
    guid
    instructorComment
  }
}
    `;

/**
 * __useUpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation__
 *
 * To run a mutation, you first call `useUpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useUpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation({
 *   variables: {
 *     expenseRecordDailyLessonInputID: // value for 'expenseRecordDailyLessonInputID'
 *     instructorComment: // value for 'instructorComment'
 *   },
 * });
 */
export function useUpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation(options: VueApolloComposable.UseMutationOptions<UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation, UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation, UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation, UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationVariables>(UpdateKollegeExpenseRecordDailyLessonInstructorCommentDocument, options);
}
export type UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutation, UpdateKollegeExpenseRecordDailyLessonInstructorCommentMutationVariables>;